import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { RootState } from "../../../redux/store";
import { CustomSingleSelectModel } from "../../../components/CustomSingleSelect";
import { storeActivityIndicator } from "../../../redux/reducers/authSlice";
import { ToolbarWrapper } from "../../../_metronic/layout/components/toolbar";
import { PageTitle } from "../../../_metronic/layout/core";
import Box from "../../../components/Box";
import Content from "../../../_metronic/layout/components/content/Content";
import { KTCard } from "../../../_metronic/helpers/components/KTCard";
import { KTCardBody } from "../../../_metronic/helpers/components/KTCardBody";
import { Helpers } from "../../../helpers/Helpers";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import { CustomMultiSelectModel } from "../../../components/CustomMultiSelect";
import { AddDeviceDataSchemeRequest } from "../../../models/request/deviceDataScheme/AddDeviceDataSchemeRequest";
import toast from "react-hot-toast";
import { DeviceDataSchemeService } from "../../../services/DeviceDataSchemeService";
import { AddDeviceDataSchemeResponse } from "../../../models/response/deviceDataScheme/AddDeviceDataSchemeResponse";
import { GetDeviceDataSchemeByIdResponse, GetDeviceDataSchemeByIdResponseDeviceDataSchemeDetail } from "../../../models/response/deviceDataScheme/GetDeviceDataSchemeByIdResponse";
import GeneralInformation from "./Components/GeneralInformation";
import Details from "./Components/Details";

const DataSettingAdd = () => {
    const auth = useSelector((state: RootState) => state.auth)
    const navigate = useNavigate();
    const pageName = "Ayarlar > Veri Ayarları"
    const [searchParams, setSearchParams] = useSearchParams();
    const dispatch = useDispatch();

    const [deviceDataSchemeId, setDeviceDataSchemeId] = useState<string | undefined>(undefined);
    const [name, setName] = useState<string | undefined>(undefined);
    const [selectedDeviceBrand, setSelectedDeviceBrand] = useState<CustomSingleSelectModel | undefined>(undefined);
    const [selectedDeviceBrandDetail, setSelectedDeviceBrandDetail] = useState<CustomSingleSelectModel | undefined>(undefined);
    const [selectedDeviceConnectionTypes, setSelectedDeviceConnectionTypes] = useState<CustomMultiSelectModel[]>([]);
    const [selectedDeviceAccessories, setSelectedDeviceAccessories] = useState<CustomMultiSelectModel[]>([]);
    const [selectedVehicleBrand, setSelectedVehicleBrand] = useState<CustomSingleSelectModel | undefined>(undefined);
    const [selectedVehicleBrandDetail, setSelectedVehicleBrandDetail] = useState<CustomSingleSelectModel | undefined>(undefined);
    const [modelYear, setModelYear] = useState<string | undefined>(undefined);
    const [deviceDataSchemeDetails, setDeviceDataSchemeDetails] = useState<GetDeviceDataSchemeByIdResponseDeviceDataSchemeDetail[]>([]);

    useEffect(() => {
        var id = searchParams.get("id");
        getData(id);
    }, [])

    useEffect(() => {
        setName([
            selectedDeviceBrand?.label,
            selectedDeviceBrandDetail?.label,
            selectedDeviceConnectionTypes?.filter(a => a && a.label && !Helpers.isEmpty(a.label)).map(a => a.label).join("-"),
            selectedDeviceAccessories?.filter(a => a && a.label && !Helpers.isEmpty(a.label)).map(a => a.label).join("-"),
            selectedVehicleBrand?.label,
            selectedVehicleBrandDetail?.label,
            modelYear
        ].filter(x => x && !Helpers.isEmpty(x)).map(x => x?.trim()).join("-"))
    }, [selectedDeviceBrand, selectedDeviceBrandDetail, selectedDeviceConnectionTypes, selectedDeviceAccessories, selectedVehicleBrand, selectedVehicleBrandDetail, modelYear])

    const getData = async (_id: string | undefined | null = undefined) => {
        try {
            dispatch(storeActivityIndicator(true))

            var id = _id ? _id : searchParams.get("id") ? searchParams.get("id") : undefined;

            if (id) {
                var response: GetDeviceDataSchemeByIdResponse = await DeviceDataSchemeService.getDeviceDataSchemeById(id);

                if (!response.isSuccess) {
                    toast.error(response.message)
                    return;
                }

                setDeviceDataSchemeId(response.data.deviceDataSchemeId);
                setName(response.data.name);

                if (response.data.deviceBrandId)
                    setSelectedDeviceBrand({ label: response.data.deviceBrandName, value: response.data.deviceBrandId });

                if (response.data.deviceBrandDetailId)
                    setSelectedDeviceBrandDetail({ label: response.data.deviceBrandDetailName, value: response.data.deviceBrandDetailId });

                setSelectedDeviceConnectionTypes(response.data.deviceDataSchemeConnectionTypes.map(function (x) {
                    return { label: x.connectionTypeName, value: x.connectionTypeId }
                }));

                setSelectedDeviceAccessories(response.data.deviceDataSchemeAccessories.map(function (x) {
                    return { label: x.accessoryName, value: x.accessoryId }
                }));

                if (response.data.vehicleBrandId)
                    setSelectedVehicleBrand({ label: response.data.vehicleBrandName, value: response.data.vehicleBrandId });

                if (response.data.vehicleBrandDetailId)
                    setSelectedVehicleBrandDetail({ label: response.data.vehicleBrandDetailName, value: response.data.vehicleBrandDetailId });

                setModelYear(response.data.modelYear?.toString())

                setDeviceDataSchemeDetails(response.data.deviceDataSchemeDetails);
            }
        } catch (error: any) {
            toast.error(error)
        }
        finally {
            dispatch(storeActivityIndicator(false))
        }
    }

    const saveDistrict = async () => {
        try {
            if (!selectedVehicleBrand || !selectedVehicleBrandDetail || !name || !modelYear || Helpers.isEmpty(modelYear) || !selectedDeviceBrandDetail || !selectedDeviceBrand || selectedDeviceConnectionTypes.length == 0) {
                toast.error('Tüm alanları doldurunuz!')
            }
            else {
                dispatch(storeActivityIndicator(true));

                var obj: AddDeviceDataSchemeRequest = {
                    deviceBrandDetailId: selectedDeviceBrandDetail?.value,
                    deviceBrandId: selectedDeviceBrand?.value,
                    deviceDataSchemeAccessoryIds: selectedDeviceAccessories.map(x => x.value),
                    deviceDataSchemeConnectionTypeIds: selectedDeviceConnectionTypes.map(x => x.value),
                    modelYear: modelYear,
                    name: name,
                    vehicleBrandDetailId: selectedVehicleBrandDetail?.value,
                    vehicleBrandId: selectedVehicleBrand?.value,
                    deviceDataSchemeId: deviceDataSchemeId,
                    deviceDataSchemeDetails: deviceDataSchemeDetails
                }

                var response: AddDeviceDataSchemeResponse = await DeviceDataSchemeService.addDeviceDataScheme(obj);

                if (!response.isSuccess) {
                    toast.error(response.message)
                    return;
                }

                toast.success(response.message)

                dispatch(storeActivityIndicator(false));
                navigate(Helpers.getGoBackUrl())
            }
        } catch (error: any) {
            toast.error(error);
            dispatch(storeActivityIndicator(false));
        }
    }

    return (
        <React.Fragment>
            <ToolbarWrapper filters={undefined} />

            <PageTitle breadcrumbs={[{
                title: pageName.split('>').slice(0, pageName.split('>').length - 1).join(' > ') + ' > ',
                isActive: false,
                path: ''
            }]}>{(pageName.split('>')[pageName.split('>').length - 1])}</PageTitle>

            <Box className="mb-10">
                <Content>
                    <GeneralInformation
                        modelYear={modelYear}
                        name={name}
                        selectedDeviceAccessories={selectedDeviceAccessories}
                        selectedDeviceBrand={selectedDeviceBrand}
                        selectedDeviceBrandDetail={selectedDeviceBrandDetail}
                        selectedDeviceConnectionTypes={selectedDeviceConnectionTypes}
                        selectedVehicleBrand={selectedVehicleBrand}
                        selectedVehicleBrandDetail={selectedVehicleBrandDetail}
                        setModelYear={setModelYear}
                        setName={setName}
                        setSelectedDeviceAccessories={setSelectedDeviceAccessories}
                        setSelectedDeviceBrand={setSelectedDeviceBrand}
                        setSelectedDeviceBrandDetail={setSelectedDeviceBrandDetail}
                        setSelectedDeviceConnectionTypes={setSelectedDeviceConnectionTypes}
                        setSelectedVehicleBrand={setSelectedVehicleBrand}
                        setSelectedVehicleBrandDetail={setSelectedVehicleBrandDetail}
                    />

                    <Details
                        deviceDataSchemeDetails={deviceDataSchemeDetails}
                        setDeviceDataSchemeDetails={setDeviceDataSchemeDetails}
                    />

                    <KTCard className="ebbe-card mt-10">
                        <KTCardBody>
                            <Box flexDirection="row" justifyContent="flex-end">
                                <Box mr="15px">

                                    <button className="btn btn-sm btn-light btn-active-light-primary" onClick={() => navigate(Helpers.getGoBackUrl())}>Geri</button>
                                </Box>
                                <Box>
                                    <button className="btn btn-primary btn-sm" onClick={saveDistrict}>Kaydet</button>
                                </Box>
                            </Box>
                        </KTCardBody>
                    </KTCard>
                </Content>
            </Box>
        </React.Fragment>
    )
}

export default DataSettingAdd;